<template>
    <section>
      <header>
        <title>{{ title }}</title>
        <a href="/" class="logo"><img src="https://cdn.modcord.com/icon.png" alt="Header Logo Alt" class="brand-visual"> Mod<span class="outline-text">Cord</span></a>
        <a class="bars" ref="bars" @click="toggleMenu()"><i class="fas fa-bars"></i></a>
        <ul ref="nav">
          <li><a href="/premium" v-if="beta_features.includes('PREMIUM_SUBSCRIPTIONS')" class="premium"><i class="fas fa-gem"></i> Premium</a></li>
          <li><a href="/dashboard"><i class="fas fa-tachometer-alt"></i> Dashboard</a></li>
          <li><a href="/commands"><i class="fas fa-terminal"></i> Commands</a></li>
          <li><a href="/support"><i class="fas fa-headset"></i> Support</a></li>
          <li><a href="/login" v-if="!authenticated"><i class="fab fa-keycdn"></i> Login</a></li>
          <li v-if="authenticated">
            <a class="user-dropdown">
              <div class="user-dropdown-button">
                <img class="avatar" v-bind:src="avatar ? `https://cdn.discordapp.com/avatars/${id}/${avatar}.png?size=32` : 'https://cdn.modcord.com/icon.png'">
                <i class="fas fa-caret-down indicator"></i>
              </div>
              <div class="user-dropdown-content">
                <ul class="user-dropdown-list">
                  <li v-if="beta_features.includes('PREMIUM_SUBSCRIPTIONS')"><a v-bind:href="`/users/${id}/subscriptions`"><i class="fas fa-money-check-alt"></i> Subscriptions</a></li>
                  <!-- <li><a v-bind:href="`/users/${id}/beta`"><i class="fas fa-flask"></i> Beta Features</a></li> -->
                  <li><a @click="signOut"><i class="fas fa-sign-out-alt"></i> Sign Out</a></li>
                </ul>
              </div>
            </a>
          </li>
        </ul>
      </header>
    </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Header",
  computed: {
    ...mapGetters(["authenticated", "username", "discriminator", "avatar", "id", "beta_features"])
  },
  methods: {
    toggleMenu() {
      let bars = this.$refs.bars;
      let nav = this.$refs.nav;

      if (!this.menuToggled) {
        this.menuToggled = true;
        bars.innerHTML = '<i class="fas fa-times" aria-hidden="true"></i>';
        nav.classList.toggle("display-block");
      } else {
        this.menuToggled = false;       
        bars.innerHTML = '<i class="fas fa-bars" aria-hidden="true"></i>';
        nav.classList.toggle("display-block");
      }
    },
    trimName: function (name, length) {
      if (name.length > length) {
        var res = "";
        for (var i = 0; i < name.length; i++) {
          if (i === length) break;
          res += name[i];
        }
        res += "...";
        return res;
      }
      return name;
    },
    signOut: async function () {
      localStorage.removeItem("token_value");
      localStorage.removeItem("token_expiration");
      this.resetUserData();
      this.storeToken(null);
      this.resetUser();
      window.location.href = `${window.location.protocol}//${window.location.host}/logout`;
    },
    ...mapActions(["storeToken", "storeUser", "resetUser", "resetUserData"])
  },
  data() {
    return {
      menuToggled: false
    }
  },
  props: ["title"]
}
</script>

<style scoped>
  header {
    width: 100%;
    height: 5em;
    box-sizing: border-box;
    background-color: var(--black-blue);
  }

  header ul {
    position: relative;
    display: flex;
    float: right;
    transition: .2s;
  }

  header ul li {
    list-style: none;
  }

  header ul li a {
    position: relative;
    display: block;
    padding: 0.6em 0.75em;
    margin-top: 1.2em;
    text-transform: uppercase;
    text-decoration: none;
    color: #ffffff;
    transition: all 0.35s;
  }

  header ul li a:hover {
    color: var(--plain-gray);
  }

  .display-block {
    transition: .2s;
  }

  .bars {
    display: none;
    position: absolute;
    z-index: 999;
    right: 1.3em;
    top: 0.54em;
    color: #ffffff;
    cursor: pointer;
    font-size: 2em;
  }

  .logo {
    margin-left: 0.5em;
    color: #ffffff;
    text-decoration: none;
    font-size: 40px;
    position: relative;
    top: 0.24em;
    transition: .35s;
    z-index: 999;
}

  .logo:hover {
    color: var(--plain-gray);
  }

  .logo .brand-visual {
    width: 43px;
    height: 43px;
    position: relative;
    top: .2em;
  }

  header .user-dropdown {
    color: #dfa32b!important;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
  }

  header .user-dropdown .avatar {
    border-radius: 50%;
    height: 37px;
    width: 37px;
  }

  header .user-dropdown .avatar, header .user-dropdown .indicator {
    position: relative;
    top: -0.4em;
  }

  header .user-dropdown .user-dropdown-button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  header .user-dropdown .indicator {
    margin-left: 0.6em;
  }

  header .user-dropdown .user-dropdown-content {
    display: none;
    position: absolute;
    background-color: var(--light-grey-blue);
    width: 185px;
    color: var(--white);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    z-index: 999;
    right: 0.8em;
    border-radius: 5px;
    top: 3em;
    overflow: hidden;
  }

  header .user-dropdown:hover .user-dropdown-content, header .user-dropdown .user-dropdown-content:hover {
    display: block;
  }

  header .user-dropdown .user-dropdown-content .user-dropdown-list {
    display: flex;
    flex-direction: column;
    width: 100%;
    text-align: left;
    background-color: transparent!important;;
  }

  header .user-dropdown .user-dropdown-content .user-dropdown-list li {
    width: 100%;
  }

  header .user-dropdown .user-dropdown-content .user-dropdown-list li a {
    cursor: pointer;
    opacity: 1;
    font-size: 0.9em;
    transition: all .2s;
    margin: 0;
    text-align: left;
  }

  header .user-dropdown .user-dropdown-content .user-dropdown-list li a:hover {
    color: var(--light-grey-blue);
    background-color: var(--white);
  }

  @media only screen and (max-width: 1080px) {
    .display-block {
      display: block;
    }

    .bars {
      display: block;
    }

    header {
      padding: 0;
    }

    .user-tag {
      padding-bottom: 1em;
    }

    header ul {
      padding-top: 1.5em;
      padding-bottom: -2px;
      margin-bottom: 2em;
      width: 100%;
      top: 0;
      display: none;
      -webkit-animation-name: animatetop;
      -webkit-animation-duration: 0.4s;
      animation-name: animatetop;
      animation-duration: 0.4s;
      background-color: var(--black-blue);
    }

    header .user-dropdown .user-dropdown-content {
      position: relative;
      right: auto;
      top: auto;
      margin-top: 0.35em;
    }

    header .user-dropdown .user-dropdown-content .user-dropdown-list {
      margin: 0;
      padding: 0;
      -webkit-animation-name: none;
      animation-name: none;
    }

    @-webkit-keyframes animatetop {
      from {
        top: -300px;
        opacity: 0
      }
      to {
        top: 0;
        opacity: 1
      }
    }

    @keyframes animatetop {
      from {
        top: -300px;
        opacity: 0
      }
      to {
        top: 0;
        opacity: 1
      }
    }

    header ul li a {
      margin: 0;
      display: block;
      text-align: center;
      color: #ffffff;
    }
  }
</style>